import { useFormInputs } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useMemo, useState } from 'react';

import { fireSafetySurveySchema } from '~/common/schemas/pcfra';

import { Container } from '../../PcfraCreateEditPage.styled';
import { SectionFormProps } from '../../types';
import { SectionHeading } from '../common.styled';
import { fireSafetySurveyFormConfig, FireSafetySurveyFormValues } from './config';

export const FireSafetySurvey: FunctionComponent<SectionFormProps> = ({
  draftValues,
  showErrors,
  onChange,
}) => {
  const [config, setConfig] = useState(
    useMemo(() => fireSafetySurveyFormConfig(draftValues?.fireSafetySurvey || {}), []),
  );

  const {
    formState: { data },
    formInputs,
  } = useFormInputs<FireSafetySurveyFormValues>({
    config,
    schema: fireSafetySurveySchema,
    value: draftValues?.fireSafetySurvey as FireSafetySurveyFormValues,
    showErrors,
  });

  useEffect(() => {
    setConfig(fireSafetySurveyFormConfig(data));
  }, [data]);

  useEffect(() => {
    onChange({ fireSafetySurvey: data });
  }, [data]);

  return (
    <Container>
      <SectionHeading>Fire safety survey</SectionHeading>
      {formInputs}
    </Container>
  );
};
